import CampaignProgramTable from './components/CampaignProgramTable'
import Card from 'components/card/Card'
import Pagination from 'components/pagination/Pagination'
import Button from 'components/button/Button'
import { Select } from 'antd'
import { useCampaignList } from './hooks/useCampaignList'
import { useLocation, useNavigate } from 'react-router-dom'
import Errors from 'components/errors/Errors'
import { useEffect } from 'react'
import Toast from 'components/toast/Toast'

const Campaign: React.FC = () => {
  const {
    status,
    mills,
    programData,
    listDataProgram,
    setLimit,
    limit,
    page,
    setPage,
    version,
    setVersion,
    partnerId,
    setPartnerId,
    totalRows,
    fetchListProgram,
  } = useCampaignList()
  const navigate = useNavigate()
  const { toast, toastContainer } = Toast()
  const location = useLocation()

  const filterOption = (input: string, option?: { label: string; value: string }) =>
    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())

  const isLoading = status == 'LOADING'
  const isFailed = status == 'FAILED'

  useEffect(() => {
    if (location?.state?.createToast == 'success') {
      toast('Anda berhasil menambahkan Program Agen', 'success')
    } else if (location?.state?.createToast == 'failed') {
      toast('Anda gagal menambahkan Program Agen', 'danger')
    }
    navigate('/campaign', { replace: true })
  }, [location?.state?.toast])

  const renderAction = () => {
    return (
      <div className="flex w-full pt-4 px-4 justify-end gap-4">
        <Select
          showSearch
          disabled={isLoading}
          className="w-[336px] dropdown-campaign"
          data-testid="input_mills"
          onChange={value => setPartnerId(value)}
          optionFilterProp="children"
          filterOption={filterOption}
          value={partnerId}
          options={mills.map(item => {
            return {
              value: item.id,
              label: item.name,
            }
          })}
        />
        <Select
          placeholder="Semua Program"
          className="w-[206px] dropdown-campaign"
          data-testid="input_program"
          onChange={val => setVersion(val)}
          value={version}
          options={programData}
        />
        <Button
          type="submit"
          data-testid="button-create"
          variant="solid-primary"
          className="py-4 w-fit font-bold text-sm h-[44px] rounded-lg"
          onClick={() => navigate('/campaign/create')}
        >
          Tambah Program Agen
        </Button>
      </div>
    )
  }

  return (
    <div className="content-wrapper">
      {toastContainer}
      <Card className="rounded-xl p-0" loading={isLoading}>
        {isFailed ? (
          <Errors
            dataTestId="vouchers"
            inverse={false}
            button
            header="Mohon maaf, permintaan Anda tidak dapat diproses."
            paragraph="terjadi kesalahan internal pada server kami. Silakan coba beberapa saat lagi."
            buttonLabel="Coba lagi"
            buttonAction={fetchListProgram}
          />
        ) : null}
        {!isFailed && (
          <>
            <Card.Header>{renderAction()}</Card.Header>
            <Card.Body className="mt-0">
              <CampaignProgramTable data={listDataProgram} isLoading={isLoading} />
            </Card.Body>
            <Card.Footer>
              <div className="px-4 py-3">
                <Pagination
                  setLimit={(limit: number) => setLimit(limit)}
                  onPageChanged={(page: number) => setPage(page)}
                  totalRows={totalRows}
                  currentPage={page}
                  limit={limit}
                  showLimitPage
                />
              </div>
            </Card.Footer>
          </>
        )}
      </Card>
    </div>
  )
}

export default Campaign
